/** @format */
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const ErrorBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
  color: theme.palette.error.main,
  fontSize: '0.75rem',
  minHeight: '20px', // Ensures consistent spacing even when empty
  lineHeight: '1.2',
}));

// TypeScript version with props interface (optional)
interface ErrorBoxProps {
  children?: React.ReactNode;
}

export const ErrorBoxWithTypes: React.FC<ErrorBoxProps> = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(1),
  color: theme.palette.error.main,
  fontSize: '0.75rem',
  minHeight: '20px',
  lineHeight: '1.2',
}));